import { useQueries } from "@tanstack/react-query";

import { systemQueryOptions } from "~/systems/data-source/system-query-options";

export function useSystemNames(systemIds: string[]) {
  const ids = [...new Set(systemIds.filter(Boolean))];
  return useQueries({
    queries: ids.map((id) => systemQueryOptions(id)),
    combine: (results) =>
      Object.fromEntries(
        results.map((result, index) => [
          ids[index],
          {
            data: result.data?.name,
            error: result.error,
            isLoading: result.isLoading,
            isError: result.isError,
          },
        ]),
      ),
  });
}
